// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"8f3fc730","787":"1a8bd34c","832":"4b2ba39a"}[chunkId] + ".chunk.css";
};